import React, { Component, Fragment } from 'react';
import cn from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import Loading from '../loading-page/loading.component.js';
import Pagination from '../pagination/pagination.component.js';
import NoData from '../no-data/no-data.component.js';

import ExperienceService from '../../features/experiences/experiences.service.js';

import './experiences.component.scss';

const ExperienceLink = ({ children, id }) => (
	<Link to={`/experiences/${id}`} className="experience-item">
		{children}
	</Link>
);
const ExperienceSelect = ({
	children, selected, handleSelect, experience,
}) => (
	<div
		className={cn('experience-item', { selected: experience.id === selected })}
		onClick={() => handleSelect(experience)}
	>
		{children}
	</div>
);

const ExperienceContent = ({ imgSrc, name, price }) => (
	<Fragment>
		<div className="background">
			<img src={imgSrc} alt={name} />
		</div>
		<div className="content">
			<div className="content-wrapper">
				<div className="title">{name}</div>
				<div className="price">
					<span className="price-wrapper">
						<span className="value">{`${price}€`}</span>
						<span className="person">
							<FormattedMessage id="experiences.per-person" />
						</span>
					</span>
				</div>
			</div>
		</div>
	</Fragment>
);

const IndexOfDefaultTicket = (array) => {
	const index = array.findIndex(price => price.defaultTicket);
	return index === -1 ? 0 : index;
};

const ExperienceItem = ({ handleSelect, selected, experience }) => (
	<Fragment>
		{!handleSelect && (
			<ExperienceLink id={experience.id}>
				<ExperienceContent
					name={experience.name}
					imgSrc={experience.coverImage.url}
					price={experience.prices[IndexOfDefaultTicket(experience.prices)]}
				/>
			</ExperienceLink>
		)}
		{handleSelect && (
			<ExperienceSelect
				selected={selected && selected.id}
				handleSelect={handleSelect}
				experience={experience}
			>
				<ExperienceContent
					name={experience.name}
					imgSrc={experience.coverImage.url}
					price={experience.prices[IndexOfDefaultTicket(experience.prices)].value}
				/>
			</ExperienceSelect>
		)}
	</Fragment>
);

function isBig(index, page) {
	return page === 1 && [0, 1, 6].includes(index);
}

function howMuchOfOffset(page = 1) {
	let offset = 0;
	if (page === 1) {
		offset = 0;
	} else if (page === 2) {
		offset = 9;
	} else {
		offset = (page - 1) * 12 - 3;
	}
	return offset;
}

function howManyPages(totalExperiences) {
	return Math.ceil((totalExperiences - 9) / 12) + 1;
}


class ExperiencesComponent extends Component {
	state = {
		page: 1,
		experiences: null,
		animateExperiencesGrid: false,
		isLoading: false,
	};

	componentDidMount() {
		const { experiences } = this.state;

		if (!experiences) {
			this.fetchData();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		const { filters } = this.props;
		const { page } = this.state;
		if (prevProps.filters !== filters) {
			this.fetchData(true);
		}

		if (prevState.page !== page) {
			this.fetchData();
		}
	}

	toPage = destinyPage => this.setState({ page: destinyPage });

	fetchData(reset = false) {
		const { page, experiences } = this.state;
		const { language, filters } = this.props;

		let p = page;
		if (reset) { p = 1; }

		this.setState({ isLoading: true });
		window.scrollTo({ top: 0, behavior: 'smooth' });

		const limit = p === 1 ? 9 : 12;
		const offset = howMuchOfOffset(p) + 1;

		ExperienceService.getExperiences(language, offset, limit, filters)
			.then((response) => {
				const oldArray = (experiences && experiences.data && !reset) ? experiences.data : [];

				this.setState(
					{
						page: p,
						animateExperiencesGrid: true,
						isLoading: false,
						experiences: {
							data: oldArray.concat(response.data),
							metadata: response.metadata,
						},
					},
				);
				setTimeout(() => {
					this.setState({ animateExperiencesGrid: false });
				}, 400);
			});
	}

	render() {
		const {
			experiences, page, animateExperiencesGrid, isLoading,
		} = this.state;

		const { handleSelect, selected, intl } = this.props;

		return (
			<div className="filtered-experiences">
				{isLoading && <Loading />}
				{!isLoading && experiences && (
					<Fragment>
						<div className="experiences-wrapper">
							<div
								className={cn('animatedLayer', {
									animating: animateExperiencesGrid,
								})}
							/>
							<div className="experiences-grid row">
								{experiences.data.length > 0
								&& experiences.data
									.slice(
										howMuchOfOffset(page),
										page === 1 ? 9 : howMuchOfOffset(page) + 12,
									)
									.map((experience, index) => (
										<div
											key={`${experience.name}-${index}`}
											className={cn(
												'col-xs-12',
												isBig(index, page)
													? 'col-sm-12 col-md-6'
													: 'col-sm-6 col-md-3',
											)}
										>
											<ExperienceItem
												handleSelect={handleSelect}
												selected={selected}
												experience={experience}
											/>
										</div>
									))}
								{(!experiences.data
								|| experiences.data.length === 0)
								&& (
									<NoData
										noDataTitle={intl.formatMessage({ id: 'experiences.no-data.title' })}
										noDataLabel={intl.formatMessage({ id: 'experiences.no-data.label' })}
									/>
								)
								}
							</div>
						</div>
						<div className="row center-xs">
							<Pagination
								skip={page}
								amountOfPages={howManyPages(experiences.metadata.total)}
								changeCallback={this.toPage}
								currentPage={page}
							/>
						</div>
					</Fragment>
				)}
			</div>
		);
	}
}

export default injectIntl(ExperiencesComponent);
